import { Snackbar, Alert, AlertColor } from "@mui/material";

export type AppSnackbarProps = {
  open: boolean;
  message: string;
  severity?: AlertColor;
  autoHideDuration?: number;
  onClose: () => void;
};

const AppSnackbar = ({
  open,
  message,
  severity = "success",
  autoHideDuration = 4000,
  onClose,
}: AppSnackbarProps) => (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={onClose} severity={severity} variant="filled" sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );

export default AppSnackbar;
